"use client";
import { PersistGate } from "redux-persist/integration/react";
import { store } from "./store";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";

export const StoreProvider = ({children} ) => {


  let persisitor = persistStore(store);

  return (
    <Provider store={store}>
      <PersistGate loading={<p>Loading....</p>} persistor={persisitor}>
        {children}
      </PersistGate>
    </Provider>
  );
};
